import { render } from "./ProductDetailCarousel.vue?vue&type=template&id=5fa93719&lang=pug"
import script from "./ProductDetailCarousel.vue?vue&type=script&lang=js"
export * from "./ProductDetailCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__